// frontend/src/components/auth/RequireBomAccess.tsx
// Guard de ruta del módulo de fichas técnicas: solo pasa quien tenga acceso a
// tdis o a avp (App Roles Empresa.TDIS, Empresa.AVP o Empresa.All). Cierra la
// entrada por URL directa, además de ocultar el enlace del menú.
//
// Mismo patrón que RequireReportsAccess y con el mismo query ['auth-me']: no
// redirige mientras carga, para no expulsar a un usuario legítimo en un refresh
// directo sobre la ruta.
//
// El cierre real está en el backend (get_bom_empresas): esto es solo la capa de
// navegación.
import { useQuery } from '@tanstack/react-query'
import { Navigate, Outlet } from 'react-router-dom'
import { authApi } from '@/services/api'

export function RequireBomAccess() {
  const { data, isLoading } = useQuery({
    queryKey: ['auth-me'],
    queryFn: authApi.getMe,
    staleTime: 60 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    retry: false,
  })
  if (isLoading) return null
  const puede = data?.empresas?.some(e => e === 'tdis' || e === 'avp')
  if (!puede) return <Navigate to="/home" replace />
  return <Outlet />
}
